import styled from 'styled-components';


export const Container = styled.div`
position: fixed;
  top: 0;
  height: 90px;
  width: 100%;
  background: linear-gradient(315deg, rgba(248, 202, 60, 1) 0%, rgba(252, 13, 117, 1) 27.59%, rgba(27, 27, 26, 1) 90.35%);
`;
export const TopComponent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
`;
export const RightComponent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 50%;
`;
export const Banner = styled.img`
  height: 107px;
  width: 192px;
  object-fit:contain;
`;
export const TextOne = styled.div`
display: flex;
align-items: center;
padding-right: 18px;
:hover {
  opacity: 0.5;
}
justify-content: center;
text-align: center;
color:#fff;
font-size: 12;
border : 1px solid transparent;
border-right-color: #000;
height: 90px;
`;
export const LastTextOne = styled.div`
display: flex;
align-items: center;
padding-right: 18px;
:hover {
  opacity: 0.5;
}
justify-content: center;
text-align: center;
color:#fff;
font-size: 12;
border : 1px solid transparent;
height: 90px;
`;